<template>
  <div class="info">
    <!-- Data Sources:
    <span class="data_source">{{dataSources}}</span>
    Updated:
    <span>{{updated}}</span> -->
  </div>
</template>

<script>
export default {
  props: ["dataSources", "updated"]
};
</script>

<style scoped>
.info {
  float: right;
  color: #4e5671;
}
.data_source {
  margin-right: 20px;
}
</style>